/*
! tailwindcss v3.4.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured `sans` font-family by default.
5. Use the user's configured `sans` font-feature-settings by default.
6. Use the user's configured `sans` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  -moz-tab-size: 4;
  /* 3 */
  -o-tab-size: 4;
     tab-size: 4;
  /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
  -webkit-font-feature-settings: normal;
          font-feature-settings: normal;
  /* 5 */
  font-variation-settings: normal;
  /* 6 */
  -webkit-tap-highlight-color: transparent;
  /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.
*/

body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured `mono` font-family by default.
2. Use the user's configured `mono` font-feature-settings by default.
3. Use the user's configured `mono` font-variation-settings by default.
4. Correct the odd `em` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  -webkit-font-feature-settings: normal;
          font-feature-settings: normal;
  /* 2 */
  font-variation-settings: normal;
  /* 3 */
  font-size: 1em;
  /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent `sub` and `sup` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  -webkit-font-feature-settings: inherit;
          font-feature-settings: inherit;
  /* 1 */
  font-variation-settings: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  font-weight: inherit;
  /* 1 */
  line-height: inherit;
  /* 1 */
  letter-spacing: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to `inherit` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-webkit-input-placeholder, textarea::-webkit-input-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input:-ms-input-placeholder, textarea:-ms-input-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::-ms-input-placeholder, textarea::-ms-input-placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden] {
  display: none;
}

:root {
  --css-interop-darkMode: class dark;
  --css-interop: true;
  --css-interop-nativewind: true;
  --background: #FAFAFA;
  --foreground: #121F3A;
  --card: #FFFFFF;
  --card-foreground: #121F3A;
  --popover:#FFFFFF;
  --popover-foreground: #121F3A;
  --primary: #286588;
  --primary-foreground:  #FFFFFF;
  --secondary: #D9D9D9;
  --secondary-foreground: #1d4261;
  --muted: #EEF1F4;
  --muted-foreground: #646E7D;
  --accent: #EEF1F4;
  --accent-foreground: #286588;
  --success: #2ADC83;
  --success-foreground: #121F3A;
  --destructive: #e14a3e;
  --destructive-foreground: #FDE7E5;
  --warning: #F4FA58;
  --warning-foreground: #5B5300;
  --border: #D9D9D9;
  --input: #D9D9D9;
  --ring: #33E6C0;
}

.\!dark:root {
  --background: 240 10% 3.9% !important;
  --foreground: 0 0% 98% !important;
  --card: 240 10% 3.9% !important;
  --card-foreground: 0 0% 98% !important;
  --popover: 240 10% 3.9% !important;
  --popover-foreground: 0 0% 98% !important;
  --primary: 0 0% 98% !important;
  --primary-foreground: 240 5.9% 10% !important;
  --secondary: 240 3.7% 15.9% !important;
  --secondary-foreground: 0 0% 98% !important;
  --muted: 240 3.7% 15.9% !important;
  --muted-foreground: 240 5% 64.9% !important;
  --accent: 240 3.7% 15.9% !important;
  --accent-foreground: 0 0% 98% !important;
  --destructive: 0 72% 51% !important;
  --destructive-foreground: 0 0% 98% !important;
  --border: 240 3.7% 15.9% !important;
  --input: 240 3.7% 15.9% !important;
  --ring: 240 4.9% 83.9% !important;
}

.dark:root {
  --background: 240 10% 3.9%;
  --foreground: 0 0% 98%;
  --card: 240 10% 3.9%;
  --card-foreground: 0 0% 98%;
  --popover: 240 10% 3.9%;
  --popover-foreground: 0 0% 98%;
  --primary: 0 0% 98%;
  --primary-foreground: 240 5.9% 10%;
  --secondary: 240 3.7% 15.9%;
  --secondary-foreground: 0 0% 98%;
  --muted: 240 3.7% 15.9%;
  --muted-foreground: 240 5% 64.9%;
  --accent: 240 3.7% 15.9%;
  --accent-foreground: 0 0% 98%;
  --destructive: 0 72% 51%;
  --destructive-foreground: 0 0% 98%;
  --border: 240 3.7% 15.9%;
  --input: 240 3.7% 15.9%;
  --ring: 240 4.9% 83.9%;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::-webkit-backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.\!visible {
  visibility: visible !important;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.static {
  position: static;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.inset-0 {
  inset: 0px;
}

.-inset-x-1\/2 {
  left: -50%;
  right: -50%;
}

.inset-x-0 {
  left: 0px;
  right: 0px;
}

.inset-x-10 {
  left: 2.5rem;
  right: 2.5rem;
}

.inset-x-4 {
  left: 1rem;
  right: 1rem;
}

.inset-x-\[20px\] {
  left: 20px;
  right: 20px;
}

.bottom-0 {
  bottom: 0px;
}

.bottom-10 {
  bottom: 2.5rem;
}

.bottom-2 {
  bottom: 0.5rem;
}

.bottom-3 {
  bottom: 0.75rem;
}

.bottom-4 {
  bottom: 1rem;
}

.bottom-\[-40px\] {
  bottom: -40px;
}

.bottom-\[12px\] {
  bottom: 12px;
}

.left-0 {
  left: 0px;
}

.left-2 {
  left: 0.5rem;
}

.left-3 {
  left: 0.75rem;
}

.left-5 {
  left: 1.25rem;
}

.left-6 {
  left: 1.5rem;
}

.right-0 {
  right: 0px;
}

.right-1 {
  right: 0.25rem;
}

.right-2 {
  right: 0.5rem;
}

.right-3 {
  right: 0.75rem;
}

.right-4 {
  right: 1rem;
}

.right-6 {
  right: 1.5rem;
}

.right-8 {
  right: 2rem;
}

.right-\[-6px\] {
  right: -6px;
}

.right-\[20px\] {
  right: 20px;
}

.right-\[22px\] {
  right: 22px;
}

.right-\[26px\] {
  right: 26px;
}

.right-\[40px\] {
  right: 40px;
}

.top-0 {
  top: 0px;
}

.top-1 {
  top: 0.25rem;
}

.top-1\/2 {
  top: 50%;
}

.top-2 {
  top: 0.5rem;
}

.top-2\.5 {
  top: 0.625rem;
}

.top-3 {
  top: 0.75rem;
}

.top-4 {
  top: 1rem;
}

.top-5 {
  top: 1.25rem;
}

.top-\[-12px\] {
  top: -12px;
}

.top-\[-50px\] {
  top: -50px;
}

.top-\[112px\] {
  top: 112px;
}

.top-\[12px\] {
  top: 12px;
}

.top-\[155px\] {
  top: 155px;
}

.top-\[16px\] {
  top: 16px;
}

.top-\[210px\] {
  top: 210px;
}

.top-\[24px\] {
  top: 24px;
}

.top-\[300px\] {
  top: 300px;
}

.top-\[30px\] {
  top: 30px;
}

.top-\[34px\] {
  top: 34px;
}

.top-\[38px\] {
  top: 38px;
}

.top-\[40px\] {
  top: 40px;
}

.top-\[52px\] {
  top: 52px;
}

.top-\[69px\] {
  top: 69px;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-50 {
  z-index: 50;
}

.m-1 {
  margin: 0.25rem;
}

.m-4 {
  margin: 1rem;
}

.m-5 {
  margin: 1.25rem;
}

.m-6 {
  margin: 1.5rem;
}

.m-8 {
  margin: 2rem;
}

.m-\[6px\] {
  margin: 6px;
}

.m-auto {
  margin: auto;
}

.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.mx-14 {
  margin-left: 3.5rem;
  margin-right: 3.5rem;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}

.mx-\[10px\] {
  margin-left: 10px;
  margin-right: 10px;
}

.mx-\[6px\] {
  margin-left: 6px;
  margin-right: 6px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.my-\[20px\] {
  margin-top: 20px;
  margin-bottom: 20px;
}

.my-\[6px\] {
  margin-top: 6px;
  margin-bottom: 6px;
}

.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.-mt-4 {
  margin-top: -1rem;
}

.mb-0 {
  margin-bottom: 0px;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-1\.5 {
  margin-bottom: 0.375rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.mb-12 {
  margin-bottom: 3rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-7 {
  margin-bottom: 1.75rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-9 {
  margin-bottom: 2.25rem;
}

.mb-\[-14px\] {
  margin-bottom: -14px;
}

.mb-\[10px\] {
  margin-bottom: 10px;
}

.mb-\[14px\] {
  margin-bottom: 14px;
}

.mb-\[2px\] {
  margin-bottom: 2px;
}

.mb-\[3px\] {
  margin-bottom: 3px;
}

.mb-\[6px\] {
  margin-bottom: 6px;
}

.mb-\[8px\] {
  margin-bottom: 8px;
}

.mb-px {
  margin-bottom: 1px;
}

.ml-1 {
  margin-left: 0.25rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

.ml-4 {
  margin-left: 1rem;
}

.ml-5 {
  margin-left: 1.25rem;
}

.ml-6 {
  margin-left: 1.5rem;
}

.ml-8 {
  margin-left: 2rem;
}

.ml-\[-32px\] {
  margin-left: -32px;
}

.ml-\[2px\] {
  margin-left: 2px;
}

.ml-\[4px\] {
  margin-left: 4px;
}

.ml-auto {
  margin-left: auto;
}

.mr-0 {
  margin-right: 0px;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-3 {
  margin-right: 0.75rem;
}

.mr-4 {
  margin-right: 1rem;
}

.mr-6 {
  margin-right: 1.5rem;
}

.mr-\[-20px\] {
  margin-right: -20px;
}

.mr-\[12px\] {
  margin-right: 12px;
}

.mr-\[2px\] {
  margin-right: 2px;
}

.mr-\[6px\] {
  margin-right: 6px;
}

.mt-0 {
  margin-top: 0px;
}

.mt-0\.5 {
  margin-top: 0.125rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mt-14 {
  margin-top: 3.5rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-20 {
  margin-top: 5rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-40 {
  margin-top: 10rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mt-9 {
  margin-top: 2.25rem;
}

.mt-\[-13px\] {
  margin-top: -13px;
}

.mt-\[-16px\] {
  margin-top: -16px;
}

.mt-\[-20px\] {
  margin-top: -20px;
}

.mt-\[13px\] {
  margin-top: 13px;
}

.mt-\[24px\] {
  margin-top: 24px;
}

.mt-\[40px\] {
  margin-top: 40px;
}

.mt-\[4px\] {
  margin-top: 4px;
}

.mt-\[9px\] {
  margin-top: 9px;
}

.mt-px {
  margin-top: 1px;
}

.block {
  display: block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.aspect-square {
  aspect-ratio: 1 / 1;
}

.size-10 {
  width: 2.5rem;
  height: 2.5rem;
}

.size-12 {
  width: 3rem;
  height: 3rem;
}

.size-2 {
  width: 0.5rem;
  height: 0.5rem;
}

.size-2\.5 {
  width: 0.625rem;
  height: 0.625rem;
}

.size-20 {
  width: 5rem;
  height: 5rem;
}

.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}

.size-3\.5 {
  width: 0.875rem;
  height: 0.875rem;
}

.size-4 {
  width: 1rem;
  height: 1rem;
}

.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}

.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}

.size-8 {
  width: 2rem;
  height: 2rem;
}

.size-\[20px\] {
  width: 20px;
  height: 20px;
}

.size-\[250px\] {
  width: 250px;
  height: 250px;
}

.size-\[9px\] {
  width: 9px;
  height: 9px;
}

.size-full {
  width: 100%;
  height: 100%;
}

.h-10 {
  height: 2.5rem;
}

.h-11 {
  height: 2.75rem;
}

.h-12 {
  height: 3rem;
}

.h-14 {
  height: 3.5rem;
}

.h-16 {
  height: 4rem;
}

.h-20 {
  height: 5rem;
}

.h-3 {
  height: 0.75rem;
}

.h-32 {
  height: 8rem;
}

.h-4 {
  height: 1rem;
}

.h-40 {
  height: 10rem;
}

.h-5 {
  height: 1.25rem;
}

.h-6 {
  height: 1.5rem;
}

.h-9 {
  height: 2.25rem;
}

.h-\[100px\] {
  height: 100px;
}

.h-\[10px\] {
  height: 10px;
}

.h-\[120px\] {
  height: 120px;
}

.h-\[140px\] {
  height: 140px;
}

.h-\[14px\] {
  height: 14px;
}

.h-\[156px\] {
  height: 156px;
}

.h-\[15px\] {
  height: 15px;
}

.h-\[16px\] {
  height: 16px;
}

.h-\[180px\] {
  height: 180px;
}

.h-\[184px\] {
  height: 184px;
}

.h-\[18px\] {
  height: 18px;
}

.h-\[190px\] {
  height: 190px;
}

.h-\[1px\] {
  height: 1px;
}

.h-\[20px\] {
  height: 20px;
}

.h-\[21px\] {
  height: 21px;
}

.h-\[23px\] {
  height: 23px;
}

.h-\[24px\] {
  height: 24px;
}

.h-\[28px\] {
  height: 28px;
}

.h-\[290px\] {
  height: 290px;
}

.h-\[2px\] {
  height: 2px;
}

.h-\[300px\] {
  height: 300px;
}

.h-\[30px\] {
  height: 30px;
}

.h-\[33px\] {
  height: 33px;
}

.h-\[35px\] {
  height: 35px;
}

.h-\[3px\] {
  height: 3px;
}

.h-\[40px\] {
  height: 40px;
}

.h-\[50px\] {
  height: 50px;
}

.h-\[62px\] {
  height: 62px;
}

.h-\[63px\] {
  height: 63px;
}

.h-\[64px\] {
  height: 64px;
}

.h-\[65px\] {
  height: 65px;
}

.h-\[66px\] {
  height: 66px;
}

.h-\[69px\] {
  height: 69px;
}

.h-\[71px\] {
  height: 71px;
}

.h-\[75px\] {
  height: 75px;
}

.h-\[80px\] {
  height: 80px;
}

.h-\[84px\] {
  height: 84px;
}

.h-\[86px\] {
  height: 86px;
}

.h-\[94px\] {
  height: 94px;
}

.h-\[var\(--radix-select-trigger-height\)\] {
  height: var(--radix-select-trigger-height);
}

.h-full {
  height: 100%;
}

.h-px {
  height: 1px;
}

.h-screen {
  height: 100vh;
}

.max-h-14 {
  max-height: 3.5rem;
}

.max-h-96 {
  max-height: 24rem;
}

.max-h-\[180px\] {
  max-height: 180px;
}

.max-h-\[200px\] {
  max-height: 200px;
}

.max-h-\[220px\] {
  max-height: 220px;
}

.max-h-\[250px\] {
  max-height: 250px;
}

.max-h-\[27px\] {
  max-height: 27px;
}

.max-h-\[330px\] {
  max-height: 330px;
}

.max-h-\[440px\] {
  max-height: 440px;
}

.min-h-10 {
  min-height: 2.5rem;
}

.min-h-32 {
  min-height: 8rem;
}

.min-h-5 {
  min-height: 1.25rem;
}

.min-h-56 {
  min-height: 14rem;
}

.min-h-6 {
  min-height: 1.5rem;
}

.min-h-72 {
  min-height: 18rem;
}

.min-h-8 {
  min-height: 2rem;
}

.min-h-\[110px\] {
  min-height: 110px;
}

.min-h-\[163px\] {
  min-height: 163px;
}

.min-h-\[288px\] {
  min-height: 288px;
}

.min-h-\[60px\] {
  min-height: 60px;
}

.min-h-\[80px\] {
  min-height: 80px;
}

.min-h-full {
  min-height: 100%;
}

.min-h-screen {
  min-height: 100vh;
}

.w-10 {
  width: 2.5rem;
}

.w-2 {
  width: 0.5rem;
}

.w-3\/4 {
  width: 75%;
}

.w-4 {
  width: 1rem;
}

.w-5 {
  width: 1.25rem;
}

.w-72 {
  width: 18rem;
}

.w-8 {
  width: 2rem;
}

.w-\[100px\] {
  width: 100px;
}

.w-\[110px\] {
  width: 110px;
}

.w-\[111px\] {
  width: 111px;
}

.w-\[112px\] {
  width: 112px;
}

.w-\[115px\] {
  width: 115px;
}

.w-\[120px\] {
  width: 120px;
}

.w-\[130px\] {
  width: 130px;
}

.w-\[133px\] {
  width: 133px;
}

.w-\[142px\] {
  width: 142px;
}

.w-\[148px\] {
  width: 148px;
}

.w-\[14px\] {
  width: 14px;
}

.w-\[150px\] {
  width: 150px;
}

.w-\[15px\] {
  width: 15px;
}

.w-\[160px\] {
  width: 160px;
}

.w-\[180px\] {
  width: 180px;
}

.w-\[1px\] {
  width: 1px;
}

.w-\[200px\] {
  width: 200px;
}

.w-\[20px\] {
  width: 20px;
}

.w-\[240px\] {
  width: 240px;
}

.w-\[241px\] {
  width: 241px;
}

.w-\[250px\] {
  width: 250px;
}

.w-\[264px\] {
  width: 264px;
}

.w-\[26px\] {
  width: 26px;
}

.w-\[270px\] {
  width: 270px;
}

.w-\[273px\] {
  width: 273px;
}

.w-\[290px\] {
  width: 290px;
}

.w-\[300px\] {
  width: 300px;
}

.w-\[30px\] {
  width: 30px;
}

.w-\[33\%\] {
  width: 33%;
}

.w-\[330px\] {
  width: 330px;
}

.w-\[332px\] {
  width: 332px;
}

.w-\[450px\] {
  width: 450px;
}

.w-\[48px\] {
  width: 48px;
}

.w-\[500px\] {
  width: 500px;
}

.w-\[52px\] {
  width: 52px;
}

.w-\[60px\] {
  width: 60px;
}

.w-\[62px\] {
  width: 62px;
}

.w-\[650px\] {
  width: 650px;
}

.w-\[70px\] {
  width: 70px;
}

.w-\[76px\] {
  width: 76px;
}

.w-\[84px\] {
  width: 84px;
}

.w-\[98px\] {
  width: 98px;
}

.w-full {
  width: 100%;
}

.w-px {
  width: 1px;
}

.min-w-20 {
  min-width: 5rem;
}

.min-w-\[100px\] {
  min-width: 100px;
}

.min-w-\[10px\] {
  min-width: 10px;
}

.min-w-\[185px\] {
  min-width: 185px;
}

.min-w-\[18px\] {
  min-width: 18px;
}

.min-w-\[300px\] {
  min-width: 300px;
}

.min-w-\[375px\] {
  min-width: 375px;
}

.min-w-\[400px\] {
  min-width: 400px;
}

.min-w-\[70px\] {
  min-width: 70px;
}

.min-w-\[82px\] {
  min-width: 82px;
}

.min-w-\[84px\] {
  min-width: 84px;
}

.min-w-\[88px\] {
  min-width: 88px;
}

.min-w-\[8rem\] {
  min-width: 8rem;
}

.min-w-\[var\(--radix-select-trigger-width\)\] {
  min-width: var(--radix-select-trigger-width);
}

.max-w-5 {
  max-width: 1.25rem;
}

.max-w-\[100px\] {
  max-width: 100px;
}

.max-w-\[110px\] {
  max-width: 110px;
}

.max-w-\[112px\] {
  max-width: 112px;
}

.max-w-\[120px\] {
  max-width: 120px;
}

.max-w-\[150px\] {
  max-width: 150px;
}

.max-w-\[172px\] {
  max-width: 172px;
}

.max-w-\[190px\] {
  max-width: 190px;
}

.max-w-\[212px\] {
  max-width: 212px;
}

.max-w-\[240px\] {
  max-width: 240px;
}

.max-w-\[245px\] {
  max-width: 245px;
}

.max-w-\[250px\] {
  max-width: 250px;
}

.max-w-\[260px\] {
  max-width: 260px;
}

.max-w-\[300px\] {
  max-width: 300px;
}

.max-w-\[350px\] {
  max-width: 350px;
}

.max-w-\[375px\] {
  max-width: 375px;
}

.max-w-\[500px\] {
  max-width: 500px;
}

.max-w-\[50px\] {
  max-width: 50px;
}

.max-w-\[550px\] {
  max-width: 550px;
}

.max-w-\[560px\] {
  max-width: 560px;
}

.max-w-\[600px\] {
  max-width: 600px;
}

.max-w-\[60px\] {
  max-width: 60px;
}

.max-w-\[650px\] {
  max-width: 650px;
}

.max-w-\[700px\] {
  max-width: 700px;
}

.max-w-\[77px\] {
  max-width: 77px;
}

.max-w-\[800px\] {
  max-width: 800px;
}

.max-w-md {
  max-width: 28rem;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-\[2\] {
  flex: 2;
}

.shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.flex-grow {
  flex-grow: 1;
}

.flex-grow-0 {
  flex-grow: 0;
}

.grow {
  flex-grow: 1;
}

.caption-bottom {
  caption-side: bottom;
}

.-translate-y-1\/2 {
  --tw-translate-y: -50%;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-evenly {
  justify-content: space-evenly;
}

.justify-stretch {
  justify-content: stretch;
}

.gap-0 {
  gap: 0px;
}

.gap-0\.5 {
  gap: 0.125rem;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-1\.5 {
  gap: 0.375rem;
}

.gap-10 {
  gap: 2.5rem;
}

.gap-14 {
  gap: 3.5rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-2\.5 {
  gap: 0.625rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-8 {
  gap: 2rem;
}

.gap-\[10px\] {
  gap: 10px;
}

.gap-\[2px\] {
  gap: 2px;
}

.gap-\[3px\] {
  gap: 3px;
}

.gap-\[7px\] {
  gap: 7px;
}

.gap-\[8px\] {
  gap: 8px;
}

.gap-y-1 {
  row-gap: 0.25rem;
}

.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}

.space-y-1\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}

.self-start {
  align-self: flex-start;
}

.self-end {
  align-self: flex-end;
}

.self-center {
  align-self: center;
}

.self-stretch {
  align-self: stretch;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-visible {
  overflow: visible;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-ellipsis {
  text-overflow: ellipsis;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-\[10px\] {
  border-radius: 10px;
}

.rounded-\[15px\] {
  border-radius: 15px;
}

.rounded-\[20px\] {
  border-radius: 20px;
}

.rounded-\[2px\] {
  border-radius: 2px;
}

.rounded-\[30px\] {
  border-radius: 30px;
}

.rounded-\[4px\] {
  border-radius: 4px;
}

.rounded-\[6px\] {
  border-radius: 6px;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-none {
  border-radius: 0px;
}

.rounded-sm {
  border-radius: 0.125rem;
}

.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

.rounded-t-\[20px\] {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.border {
  border-width: 1px;
}

.border-0 {
  border-width: 0px;
}

.border-2 {
  border-width: 2px;
}

.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}

.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-b-\[3px\] {
  border-bottom-width: 3px;
}

.border-l-2 {
  border-left-width: 2px;
}

.border-r {
  border-right-width: 1px;
}

.border-t {
  border-top-width: 1px;
}

.border-\[\#F0F0F0\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 240 240 / var(--tw-border-opacity));
}

.border-border {
  border-color: var(--border);
}

.border-calm-blue {
  --tw-border-opacity: 1;
  border-color: rgb(40 101 136 / var(--tw-border-opacity));
}

.border-cyan-800 {
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity));
}

.border-dark-grey {
  --tw-border-opacity: 1;
  border-color: rgb(102 112 128 / var(--tw-border-opacity));
}

.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}

.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}

.border-input {
  border-color: var(--input);
}

.border-light-grey {
  --tw-border-opacity: 1;
  border-color: rgb(217 217 217 / var(--tw-border-opacity));
}

.border-midnight-blue {
  --tw-border-opacity: 1;
  border-color: rgb(18 31 58 / var(--tw-border-opacity));
}

.border-primary {
  border-color: var(--primary);
}

.border-red {
  --tw-border-opacity: 1;
  border-color: rgb(225 74 62 / var(--tw-border-opacity));
}

.border-red-orange {
  --tw-border-opacity: 1;
  border-color: rgb(225 74 62 / var(--tw-border-opacity));
}

.border-salmon {
  --tw-border-opacity: 1;
  border-color: rgb(252 119 146 / var(--tw-border-opacity));
}

.border-teal {
  --tw-border-opacity: 1;
  border-color: rgb(117 250 212 / var(--tw-border-opacity));
}

.border-transparent {
  border-color: transparent;
}

.border-warm-grey {
  --tw-border-opacity: 1;
  border-color: rgb(167 164 164 / var(--tw-border-opacity));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}

.border-b-calm-blue {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(40 101 136 / var(--tw-border-opacity));
}

.border-b-light-grey {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(217 217 217 / var(--tw-border-opacity));
}

.border-b-off-white {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(250 250 250 / var(--tw-border-opacity));
}

.border-b-warm-grey {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(167 164 164 / var(--tw-border-opacity));
}

.border-r-light-grey {
  --tw-border-opacity: 1;
  border-right-color: rgb(217 217 217 / var(--tw-border-opacity));
}

.bg-\[\#144460\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 68 96 / var(--tw-bg-opacity));
}

.bg-\[\#244075\] {
  --tw-bg-opacity: 1;
  background-color: rgb(36 64 117 / var(--tw-bg-opacity));
}

.bg-\[\#B2C7D499\] {
  background-color: #B2C7D499;
}

.bg-\[\#fcfcfc\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 252 252 / var(--tw-bg-opacity));
}

.bg-\[rgba\(40\2c 101\2c 136\2c 0\.5\)\] {
  background-color: rgba(40,101,136,0.5);
}

.bg-accent {
  background-color: var(--accent);
}

.bg-background {
  background-color: var(--background);
}

.bg-beige {
  --tw-bg-opacity: 1;
  background-color: rgb(223 205 185 / var(--tw-bg-opacity));
}

.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.bg-black\/30 {
  background-color: rgb(0 0 0 / 0.3);
}

.bg-black\/50 {
  background-color: rgb(0 0 0 / 0.5);
}

.bg-black\/70 {
  background-color: rgb(0 0 0 / 0.7);
}

.bg-border {
  background-color: var(--border);
}

.bg-calm-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(40 101 136 / var(--tw-bg-opacity));
}

.bg-calm-blue\/50 {
  background-color: rgb(40 101 136 / 0.5);
}

.bg-calm-blue\/95 {
  background-color: rgb(40 101 136 / 0.95);
}

.bg-card {
  background-color: var(--card);
}

.bg-destructive {
  background-color: var(--destructive);
}

.bg-foreground {
  background-color: var(--foreground);
}

.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}

.bg-grey {
  --tw-bg-opacity: 1;
  background-color: rgb(238 241 244 / var(--tw-bg-opacity));
}

.bg-light-grey {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}

.bg-light-grey\/50 {
  background-color: rgb(217 217 217 / 0.5);
}

.bg-lightest {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-lightest\/60 {
  background-color: rgb(255 255 255 / 0.6);
}

.bg-midnight-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(18 31 58 / var(--tw-bg-opacity));
}

.bg-muted {
  background-color: var(--muted);
}

.bg-neon-yellow {
  --tw-bg-opacity: 1;
  background-color: rgb(244 250 88 / var(--tw-bg-opacity));
}

.bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}

.bg-off-white {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}

.bg-off-white\/30 {
  background-color: rgb(250 250 250 / 0.3);
}

.bg-off-white\/35 {
  background-color: rgb(250 250 250 / 0.35);
}

.bg-popover {
  background-color: var(--popover);
}

.bg-primary {
  background-color: var(--primary);
}

.bg-red {
  --tw-bg-opacity: 1;
  background-color: rgb(225 74 62 / var(--tw-bg-opacity));
}

.bg-red-orange {
  --tw-bg-opacity: 1;
  background-color: rgb(225 74 62 / var(--tw-bg-opacity));
}

.bg-salmon {
  --tw-bg-opacity: 1;
  background-color: rgb(252 119 146 / var(--tw-bg-opacity));
}

.bg-secondary {
  background-color: var(--secondary);
}

.bg-success {
  background-color: var(--success);
}

.bg-teal {
  --tw-bg-opacity: 1;
  background-color: rgb(117 250 212 / var(--tw-bg-opacity));
}

.bg-transparent {
  background-color: transparent;
}

.bg-warm-grey {
  --tw-bg-opacity: 1;
  background-color: rgb(167 164 164 / var(--tw-bg-opacity));
}

.bg-warning {
  background-color: var(--warning);
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-white\/95 {
  background-color: rgb(255 255 255 / 0.95);
}

.p-0 {
  padding: 0px;
}

.p-0\.5 {
  padding: 0.125rem;
}

.p-1 {
  padding: 0.25rem;
}

.p-1\.5 {
  padding: 0.375rem;
}

.p-10 {
  padding: 2.5rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-2\.5 {
  padding: 0.625rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-3\.5 {
  padding: 0.875rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-8 {
  padding: 2rem;
}

.p-\[10px\] {
  padding: 10px;
}

.p-\[14px\] {
  padding: 14px;
}

.p-\[15px\] {
  padding: 15px;
}

.p-\[2px\] {
  padding: 2px;
}

.p-\[5px\] {
  padding: 5px;
}

.p-\[7px\] {
  padding: 7px;
}

.p-\[8px\] {
  padding: 8px;
}

.p-px {
  padding: 1px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-1\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.px-\[0\.3rem\] {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}

.px-\[12px\] {
  padding-left: 12px;
  padding-right: 12px;
}

.px-\[14px\] {
  padding-left: 14px;
  padding-right: 14px;
}

.px-\[16px\] {
  padding-left: 16px;
  padding-right: 16px;
}

.px-\[5px\] {
  padding-left: 5px;
  padding-right: 5px;
}

.px-\[6px\] {
  padding-left: 6px;
  padding-right: 6px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.py-0\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.py-1\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.py-2\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-3\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.py-\[0\.2rem\] {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.py-\[10px\] {
  padding-top: 10px;
  padding-bottom: 10px;
}

.py-\[14px\] {
  padding-top: 14px;
  padding-bottom: 14px;
}

.py-\[15px\] {
  padding-top: 15px;
  padding-bottom: 15px;
}

.py-\[26px\] {
  padding-top: 26px;
  padding-bottom: 26px;
}

.py-\[8px\] {
  padding-top: 8px;
  padding-bottom: 8px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pb-1 {
  padding-bottom: 0.25rem;
}

.pb-10 {
  padding-bottom: 2.5rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pb-20 {
  padding-bottom: 5rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pb-5 {
  padding-bottom: 1.25rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pb-8 {
  padding-bottom: 2rem;
}

.pb-\[15px\] {
  padding-bottom: 15px;
}

.pb-\[50px\] {
  padding-bottom: 50px;
}

.pb-\[8px\] {
  padding-bottom: 8px;
}

.pl-0 {
  padding-left: 0px;
}

.pl-1 {
  padding-left: 0.25rem;
}

.pl-10 {
  padding-left: 2.5rem;
}

.pl-2 {
  padding-left: 0.5rem;
}

.pl-2\.5 {
  padding-left: 0.625rem;
}

.pl-3 {
  padding-left: 0.75rem;
}

.pl-4 {
  padding-left: 1rem;
}

.pl-6 {
  padding-left: 1.5rem;
}

.pl-8 {
  padding-left: 2rem;
}

.pl-\[110px\] {
  padding-left: 110px;
}

.pl-\[2px\] {
  padding-left: 2px;
}

.pl-\[6px\] {
  padding-left: 6px;
}

.pr-0 {
  padding-right: 0px;
}

.pr-1 {
  padding-right: 0.25rem;
}

.pr-2 {
  padding-right: 0.5rem;
}

.pr-3 {
  padding-right: 0.75rem;
}

.pr-4 {
  padding-right: 1rem;
}

.pr-5 {
  padding-right: 1.25rem;
}

.pr-6 {
  padding-right: 1.5rem;
}

.pr-8 {
  padding-right: 2rem;
}

.pr-\[40px\] {
  padding-right: 40px;
}

.pt-0 {
  padding-top: 0px;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pt-16 {
  padding-top: 4rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pt-2\.5 {
  padding-top: 0.625rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pt-8 {
  padding-top: 2rem;
}

.pt-\[11px\] {
  padding-top: 11px;
}

.pt-\[17px\] {
  padding-top: 17px;
}

.pt-\[20px\] {
  padding-top: 20px;
}

.pt-\[2px\] {
  padding-top: 2px;
}

.pt-\[3px\] {
  padding-top: 3px;
}

.pt-\[50px\] {
  padding-top: 50px;
}

.pt-\[60px\] {
  padding-top: 60px;
}

.pt-\[6px\] {
  padding-top: 6px;
}

.pt-\[8px\] {
  padding-top: 8px;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.align-middle {
  vertical-align: middle;
}

.font-figtree-bold {
  font-family: Figtree-Bold;
}

.font-figtree-extrabold {
  font-family: Figtree-ExtraBold;
}

.font-spacegrotesk {
  font-family: SpaceGrotesk-Regular;
}

.font-spacegrotesk-bold {
  font-family: SpaceGrotesk-Bold;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-\[10px\] {
  font-size: 10px;
}

.text-\[11px\] {
  font-size: 11px;
}

.text-\[12px\] {
  font-size: 12px;
}

.text-\[13px\] {
  font-size: 13px;
}

.text-\[14px\] {
  font-size: 14px;
}

.text-\[15px\] {
  font-size: 15px;
}

.text-\[16px\] {
  font-size: 16px;
}

.text-\[17px\] {
  font-size: 17px;
}

.text-\[18px\] {
  font-size: 18px;
}

.text-\[19px\] {
  font-size: 19px;
}

.text-\[20px\] {
  font-size: 20px;
}

.text-\[24px\] {
  font-size: 24px;
}

.text-\[26px\] {
  font-size: 26px;
}

.text-\[28px\] {
  font-size: 28px;
}

.text-\[36px\] {
  font-size: 36px;
}

.text-\[38px\] {
  font-size: 38px;
}

.text-\[40px\] {
  font-size: 40px;
}

.text-\[45px\] {
  font-size: 45px;
}

.text-\[60px\] {
  font-size: 60px;
}

.text-\[9px\] {
  font-size: 9px;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.font-bold {
  font-weight: 700;
}

.font-extrabold {
  font-weight: 800;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.font-semibold {
  font-weight: 600;
}

.uppercase {
  text-transform: uppercase;
}

.italic {
  font-style: italic;
}

.leading-3 {
  line-height: .75rem;
}

.leading-4 {
  line-height: 1rem;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-7 {
  line-height: 1.75rem;
}

.leading-\[12px\] {
  line-height: 12px;
}

.leading-\[14px\] {
  line-height: 14px;
}

.leading-\[16px\] {
  line-height: 16px;
}

.leading-\[18px\] {
  line-height: 18px;
}

.leading-\[20px\] {
  line-height: 20px;
}

.leading-\[22px\] {
  line-height: 22px;
}

.leading-\[24px\] {
  line-height: 24px;
}

.leading-\[28px\] {
  line-height: 28px;
}

.leading-\[30px\] {
  line-height: 30px;
}

.leading-\[42px\] {
  line-height: 42px;
}

.leading-\[45px\] {
  line-height: 45px;
}

.leading-\[50px\] {
  line-height: 50px;
}

.leading-\[60px\] {
  line-height: 60px;
}

.leading-none {
  line-height: 1;
}

.leading-snug {
  line-height: 1.375;
}

.leading-tight {
  line-height: 1.25;
}

.tracking-\[-0\.072px\] {
  letter-spacing: -0.072px;
}

.tracking-\[-0\.096px\] {
  letter-spacing: -0.096px;
}

.tracking-\[-0\.112px\] {
  letter-spacing: -0.112px;
}

.tracking-\[0\.01px\] {
  letter-spacing: 0.01px;
}

.tracking-\[0\.12px\] {
  letter-spacing: 0.12px;
}

.tracking-\[0\.14px\] {
  letter-spacing: 0.14px;
}

.tracking-\[0\.16px\] {
  letter-spacing: 0.16px;
}

.tracking-\[0\.2px\] {
  letter-spacing: 0.2px;
}

.tracking-\[0\.6px\] {
  letter-spacing: 0.6px;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.tracking-tighter {
  letter-spacing: -0.05em;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.text-accent-foreground {
  color: var(--accent-foreground);
}

.text-beige {
  --tw-text-opacity: 1;
  color: rgb(223 205 185 / var(--tw-text-opacity));
}

.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}

.text-calm-blue {
  --tw-text-opacity: 1;
  color: rgb(40 101 136 / var(--tw-text-opacity));
}

.text-card-foreground {
  color: var(--card-foreground);
}

.text-dark-grey {
  --tw-text-opacity: 1;
  color: rgb(102 112 128 / var(--tw-text-opacity));
}

.text-darkest {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.text-destructive {
  color: var(--destructive);
}

.text-destructive-foreground {
  color: var(--destructive-foreground);
}

.text-foreground {
  color: var(--foreground);
}

.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}

.text-light-grey {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}

.text-lightest {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-midnight-blue {
  --tw-text-opacity: 1;
  color: rgb(18 31 58 / var(--tw-text-opacity));
}

.text-mustard-yellow {
  --tw-text-opacity: 1;
  color: rgb(225 179 62 / var(--tw-text-opacity));
}

.text-muted-foreground {
  color: var(--muted-foreground);
}

.text-off-white {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}

.text-popover-foreground {
  color: var(--popover-foreground);
}

.text-primary {
  color: var(--primary);
}

.text-primary-foreground {
  color: var(--primary-foreground);
}

.text-red {
  --tw-text-opacity: 1;
  color: rgb(225 74 62 / var(--tw-text-opacity));
}

.text-red-orange {
  --tw-text-opacity: 1;
  color: rgb(225 74 62 / var(--tw-text-opacity));
}

.text-salmon {
  --tw-text-opacity: 1;
  color: rgb(252 119 146 / var(--tw-text-opacity));
}

.text-secondary-foreground {
  color: var(--secondary-foreground);
}

.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}

.text-success-foreground {
  color: var(--success-foreground);
}

.text-teal {
  --tw-text-opacity: 1;
  color: rgb(117 250 212 / var(--tw-text-opacity));
}

.text-warm-grey {
  --tw-text-opacity: 1;
  color: rgb(167 164 164 / var(--tw-text-opacity));
}

.text-warning-foreground {
  color: var(--warning-foreground);
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-wire-frames-grey {
  --tw-text-opacity: 1;
  color: rgb(102 112 128 / var(--tw-text-opacity));
}

.underline {
  text-decoration-line: underline;
}

.opacity-0 {
  opacity: 0;
}

.opacity-100 {
  opacity: 1;
}

.opacity-20 {
  opacity: 0.2;
}

.opacity-25 {
  opacity: 0.25;
}

.opacity-35 {
  opacity: 0.35;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-50 {
  opacity: 0.5;
}

.shadow {
  --tw-shadow: 0px 1px 4px rgba(0, 0, 0, 0.35);
  --tw-shadow-colored: 0px 1px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-md {
  --tw-shadow: 0px 3px 10px rgba(0, 0, 0, 0.35);
  --tw-shadow-colored: 0px 3px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow:  0px 1px 1px rgba(0, 0, 0, 0.35);
  --tw-shadow-colored: 0px 1px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-light-grey {
  --tw-shadow-color: #D9D9D9;
  --tw-shadow: var(--tw-shadow-colored);
}

.shadow-midnight-blue\/50 {
  --tw-shadow-color: rgb(18 31 58 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline {
  outline-style: solid;
}

.outline-\[6px\] {
  outline-width: 6px;
}

.outline-lightest {
  outline-color: #FFFFFF;
}

.filter {
  -webkit-filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
          filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.color-calm-blue {
  --tw-text-opacity: 1;
  color: rgb(40 101 136 / var(--tw-text-opacity));
}

.color-darkest {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

@-webkit-keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    -webkit-transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
            transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@keyframes enter {
  from {
    opacity: var(--tw-enter-opacity, 1);
    -webkit-transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
            transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}

@-webkit-keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    -webkit-transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
            transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

@keyframes exit {
  to {
    opacity: var(--tw-exit-opacity, 1);
    -webkit-transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
            transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}

.duration-200 {
  -webkit-animation-duration: 200ms;
          animation-duration: 200ms;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  /* width of the entire scrollbar */
}

*::-webkit-scrollbar-track {
  background-color: white;
  /* color of the tracking area */
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  /* color of the scroll thumb */
  border-radius: 6px;
  /* roundness of the scroll thumb */
}

*::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.4);
  /* color of the scroll thumb */
  border-radius: 6px;
  /* roundness of the scroll thumb */
}

.file\:border-0::-webkit-file-upload-button {
  border-width: 0px;
}

.file\:border-0::file-selector-button {
  border-width: 0px;
}

.file\:bg-transparent::-webkit-file-upload-button {
  background-color: transparent;
}

.file\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\:font-medium::-webkit-file-upload-button {
  font-weight: 500;
}

.file\:font-medium::file-selector-button {
  font-weight: 500;
}

.placeholder\:font-spacegrotesk::-webkit-input-placeholder {
  font-family: SpaceGrotesk-Regular;
}

.placeholder\:font-spacegrotesk:-ms-input-placeholder {
  font-family: SpaceGrotesk-Regular;
}

.placeholder\:font-spacegrotesk::-ms-input-placeholder {
  font-family: SpaceGrotesk-Regular;
}

.placeholder\:font-spacegrotesk::placeholder {
  font-family: SpaceGrotesk-Regular;
}

.placeholder\:text-muted-foreground::-webkit-input-placeholder {
  color: var(--muted-foreground);
}

.placeholder\:text-muted-foreground:-ms-input-placeholder {
  color: var(--muted-foreground);
}

.placeholder\:text-muted-foreground::-ms-input-placeholder {
  color: var(--muted-foreground);
}

.placeholder\:text-muted-foreground::placeholder {
  color: var(--muted-foreground);
}

.placeholder\:text-warm-grey::-webkit-input-placeholder {
  --tw-text-opacity: 1;
  color: rgb(167 164 164 / var(--tw-text-opacity));
}

.placeholder\:text-warm-grey:-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgb(167 164 164 / var(--tw-text-opacity));
}

.placeholder\:text-warm-grey::-ms-input-placeholder {
  --tw-text-opacity: 1;
  color: rgb(167 164 164 / var(--tw-text-opacity));
}

.placeholder\:text-warm-grey::placeholder {
  --tw-text-opacity: 1;
  color: rgb(167 164 164 / var(--tw-text-opacity));
}

.first\:mt-0:first-child {
  margin-top: 0px;
}

.last\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.hover\:bg-\[\#1B5A7F\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(27 90 127 / var(--tw-bg-opacity));
}

.hover\:bg-\[\#5AC0A3\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 192 163 / var(--tw-bg-opacity));
}

.hover\:bg-\[\#68DCBB\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(104 220 187 / var(--tw-bg-opacity));
}

.hover\:bg-\[\#EEF1F4\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 241 244 / var(--tw-bg-opacity));
}

.hover\:bg-grey:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 241 244 / var(--tw-bg-opacity));
}

.active\:bg-\[\#144460\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(20 68 96 / var(--tw-bg-opacity));
}

.active\:bg-\[\#5AC0A3\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(90 192 163 / var(--tw-bg-opacity));
}

.active\:bg-\[\#D3D5D8\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(211 213 216 / var(--tw-bg-opacity));
}

.active\:bg-accent:active {
  background-color: var(--accent);
}

.active\:opacity-80:active {
  opacity: 0.8;
}

.active\:opacity-90:active {
  opacity: 0.9;
}

.disabled\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\:opacity-0 {
  opacity: 0;
}

.group:hover .group-hover\:opacity-100 {
  opacity: 1;
}

.group:active .group-active\:text-accent-foreground {
  color: var(--accent-foreground);
}

.group:active .group-active\:text-secondary-foreground {
  color: var(--secondary-foreground);
}

.group:active .group-active\:underline {
  text-decoration-line: underline;
}

.data-\[side\=bottom\]\:translate-y-1[data-side=bottom] {
  --tw-translate-y: 0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\[side\=left\]\:-translate-x-1[data-side=left] {
  --tw-translate-x: -0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\[side\=right\]\:translate-x-1[data-side=right] {
  --tw-translate-x: 0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\[side\=top\]\:-translate-y-1[data-side=top] {
  --tw-translate-y: -0.25rem;
  -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
          transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\[side\=bottom\]\:slide-in-from-top-2[data-side=bottom] {
  --tw-enter-translate-y: -0.5rem;
}

.data-\[side\=left\]\:slide-in-from-right-2[data-side=left] {
  --tw-enter-translate-x: 0.5rem;
}

.data-\[side\=right\]\:slide-in-from-left-2[data-side=right] {
  --tw-enter-translate-x: -0.5rem;
}

.data-\[side\=top\]\:slide-in-from-bottom-2[data-side=top] {
  --tw-enter-translate-y: 0.5rem;
}

.web\:pointer-events-none {
  pointer-events: none;
}

.web\:top-3 {
  top: 0.75rem;
}

.web\:mb-20 {
  margin-bottom: 5rem;
}

.web\:ml-6 {
  margin-left: 1.5rem;
}

.web\:mt-1 {
  margin-top: 0.25rem;
}

.web\:mt-px {
  margin-top: 1px;
}

.web\:flex {
  display: flex;
}

.web\:inline-flex {
  display: inline-flex;
}

.web\:grid {
  display: grid;
}

.web\:h-\[72px\] {
  height: 72px;
}

.web\:max-h-dvh {
  max-height: 100dvh;
}

.web\:max-h-full {
  max-height: 100%;
}

.web\:w-\[354px\] {
  width: 354px;
}

.web\:w-\[375px\] {
  width: 375px;
}

.web\:w-full {
  width: 100%;
}

.web\:flex-1 {
  flex: 1 1 0%;
}

@-webkit-keyframes accordion-down {
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes accordion-down {
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}

.web\:animate-accordion-down {
  -webkit-animation: accordion-down 0.2s ease-out;
          animation: accordion-down 0.2s ease-out;
}

@-webkit-keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}

@keyframes accordion-up {
  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}

.web\:animate-accordion-up {
  -webkit-animation: accordion-up 0.2s ease-out;
          animation: accordion-up 0.2s ease-out;
}

.web\:cursor-auto {
  cursor: auto;
}

.web\:cursor-default {
  cursor: default;
}

.web\:cursor-not-allowed {
  cursor: not-allowed;
}

.web\:select-none {
  -webkit-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.web\:select-text {
  -webkit-user-select: text;
      -ms-user-select: text;
          user-select: text;
}

.web\:scroll-m-20 {
  scroll-margin: 5rem;
}

.web\:flex-col {
  flex-direction: column;
}

.web\:overflow-y-auto {
  overflow-y: auto;
}

.web\:whitespace-nowrap {
  white-space: nowrap;
}

.web\:py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.web\:underline-offset-4 {
  text-underline-offset: 4px;
}

.web\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.web\:ring-offset-background {
  --tw-ring-offset-color: var(--background);
}

.web\:transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.web\:transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.web\:animate-in {
  -webkit-animation-name: enter;
          animation-name: enter;
  -webkit-animation-duration: 150ms;
          animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}

.web\:animate-out {
  -webkit-animation-name: exit;
          animation-name: exit;
  -webkit-animation-duration: 150ms;
          animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}

.web\:fade-in-0 {
  --tw-enter-opacity: 0;
}

.web\:fade-out-0 {
  --tw-exit-opacity: 0;
}

.web\:zoom-in-95 {
  --tw-enter-scale: .95;
}

.web\:zoom-out {
  --tw-exit-scale: 0;
}

.web\:zoom-out-95 {
  --tw-exit-scale: .95;
}

.web\:hover\:bg-accent:hover {
  background-color: var(--accent);
}

.web\:hover\:text-accent-foreground:hover {
  color: var(--accent-foreground);
}

.web\:hover\:underline:hover {
  text-decoration-line: underline;
}

.web\:hover\:opacity-80:hover {
  opacity: 0.8;
}

.web\:hover\:opacity-90:hover {
  opacity: 0.9;
}

.web\:focus\:bg-accent:focus {
  background-color: var(--accent);
}

.web\:focus\:underline:focus {
  text-decoration-line: underline;
}

.web\:focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.web\:focus\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.web\:focus\:ring-ring:focus {
  --tw-ring-color: var(--ring);
}

.web\:focus\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.web\:focus-visible\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.web\:focus-visible\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.web\:focus-visible\:ring-ring:focus-visible {
  --tw-ring-color: var(--ring);
}

.web\:focus-visible\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.group:hover .web\:group-hover\:text-muted-foreground {
  color: var(--muted-foreground);
}

.group:hover .web\:group-hover\:underline {
  text-decoration-line: underline;
}

.group:focus .web\:group-focus\:text-accent-foreground {
  color: var(--accent-foreground);
}

.peer:disabled ~ .web\:peer-disabled\:cursor-not-allowed {
  cursor: not-allowed;
}

.peer:disabled ~ .web\:peer-disabled\:opacity-70 {
  opacity: 0.7;
}

.web\:data-\[state\=selected\]\:bg-muted[data-state=selected] {
  background-color: var(--muted);
}

.web\:data-\[side\=bottom\]\:slide-in-from-top-2[data-side=bottom] {
  --tw-enter-translate-y: -0.5rem;
}

.web\:data-\[side\=left\]\:slide-in-from-right-2[data-side=left] {
  --tw-enter-translate-x: 0.5rem;
}

.web\:data-\[side\=right\]\:slide-in-from-left-2[data-side=right] {
  --tw-enter-translate-x: -0.5rem;
}

.web\:data-\[side\=top\]\:slide-in-from-bottom-2[data-side=top] {
  --tw-enter-translate-y: 0.5rem;
}

.dark\:bg-muted:is(.dark *) {
  background-color: var(--muted);
}

@media (min-width: 1024px) {
  .lg\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

.\[\&\:has\(\[role\=checkbox\]\)\]\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}

.\[\&\>span\]\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.\[\&\>tr\]\:last\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}

.\[\&_tr\:last-child\]\:border-0 tr:last-child {
  border-width: 0px;
}

.\[\&_tr\]\:border-b tr {
  border-bottom-width: 1px;
}
